module.exports = __webpack_public_path__ + "static/img/util-bg@m.3afbd31.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/hyundai-steel/util-bg@m.png
// module id = jIfD
// module chunks = 0